import { render } from "./teamLessonInfo.vue?vue&type=template&id=66874617&scoped=true"
import script from "./teamLessonInfo.vue?vue&type=script&lang=js"
export * from "./teamLessonInfo.vue?vue&type=script&lang=js"

import "./teamLessonInfo.vue?vue&type=style&index=0&id=66874617&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66874617"]])

export default __exports__